import OwnerChatGubagoo from './OwnerChatGubagoo';
export default OwnerChatGubagoo;